/**
 * Single source of truth for the layout-template item-variant vocabulary.
 *
 * `variant` is stored as free-text on each ItemPlaceholderNode (max 40 chars,
 * no Zod enum) — admin can still type a custom value. These presets are just
 * UX shortcuts in the editor (item placeholder toolbar dropdown + carousel
 * bulk-set chip row) + visual cues in the admin preview renderer.
 *
 * Mirrors the public Next.js renderer's expected CSS class hints. When this
 * list changes, also update memory `project_layout_variant_vocab.md` so the
 * public renderer stays in sync.
 */

export const VARIANT_PRESETS = [
  'hero',
  'card',
  'featured',
  'thumb-sm',
  'thumb-md',
  'thumb-lg',
  'compact',
] as const;

export type VariantPreset = (typeof VARIANT_PRESETS)[number];

/**
 * Horizontal-layout thumb sizes in Tailwind classes. Keys are the variant
 * string the renderer sees; legacy `'thumb'` aliases to `'thumb-sm'` so
 * older templates stored before the split keep their existing look.
 */
export const HORIZONTAL_THUMB_CLASS: Record<string, string> = {
  thumb: 'h-7 w-10', // legacy alias = small
  'thumb-sm': 'h-7 w-10',
  'thumb-md': 'h-10 w-16',
  'thumb-lg': 'h-14 w-24',
};

/** Default thumb class when variant has no entry in HORIZONTAL_THUMB_CLASS. */
export const DEFAULT_THUMB_CLASS = 'h-7 w-10';
